import assert from "assert";

const padToTwoDigits = (num: number) => {
  assert(num >= 0 && num < 100);
  return num < 10 ? "0" + num : num;
};

export const renderTime = (timeInSeconds: number) =>
  `${Math.floor(timeInSeconds / 60)}:${padToTwoDigits(timeInSeconds % 60)}`;
